const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "EQUIPMENT_TYPES_RETRIEVED":
            return action.equipmentTypes;

        default:
            return state;
    }
}
